import React, { useState } from "react";
import { Formik, Field, Form as FormikForm } from "formik";
import * as Yup from "yup";
import Image from "react-bootstrap/Image";
import { Button, Form } from "react-bootstrap";
import CustomForm from "../../../components/customcomponents/CustomForm";
import { Link } from "react-router-dom";
import { IMAGES } from "../../../assets/images/images";
import { Icon } from "@iconify/react";
import { registerUser } from "../../../utility/apiServices/userServices";
import { useSetRecoilState } from "recoil";
import {
  emailState,
  UseridState,
} from "../../../utility/globle/recoil/atom";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { phoneRegExp } from "../../../utility/local/constants";
import GoogleLoginButton from "./auth/GoogleLoginButton";
import { useTranslation } from "react-i18next";

const UserSignUp = () => {
  const navigate = useNavigate();
  const [Loading, setLoading] = useState(false);
  const { t , i18n } = useTranslation();
  const setId = useSetRecoilState(UseridState);
  const setEmail = useSetRecoilState(emailState);
  const initialValues = {
    name: "",
    email: "",
    phone_number: "",
    password: "",
    // used_referral_code: "",
    is_infulencer: false,
  };

  const currentLanguage = i18n.language;
  const validationSchema = Yup.object().shape({
    name: Yup.string().min(3).required(t("signup.name_required")),
    email: Yup.string()
      .email(t("signup.invalid_email"))
      .required(t("signup.email_required")),
    phone_number: Yup.string()
      .min(10)
      .max(20)
      .required(t("signup.phone_required"))
      .matches(phoneRegExp, t("signup.phone_invalid")),
    password: Yup.string().min(8).required(t("signup.password_required")),
    is_infulencer: Yup.boolean(),
  });

  const handleSubmit = async (values) => {
    console.log("values :", values);
    try {
      setLoading(true);
      let response = await registerUser({
        email: values.email,
        name: values.name,
        phone_number: values.phone_number,
        password: values.password,
        status: "active",
        user_role: "user",
        account_type: "user",
        is_influencer: values.is_infulencer,
      });

      if (response.status) {
        setLoading(false);
        setId(response?.data?.id);
        setEmail(response?.data?.email);
        navigate("/verify-otp");
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          text: response?.message || t("signup.user_exists"),
        });
      }
    } catch (err) {
      console.log("error in handleSubmit", err);
    }
  };


  return (
    <section className="login_box">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6 hideloginimg">
            <div className="login_bg">
              <Image src={IMAGES.Login_Bg} className="img-fluid" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="loginBody">
              <h1>{t("signup.create_account")}</h1>
              <p className="para">{t("signup.fill_details")}</p>

              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                validateOnChange
                validateOnBlur
              >
                {({ errors, touched, setFieldValue }) => (
                  <FormikForm>
                    <Form.Group className="mb-3">
                      <Field name="name">
                        {({ field }) => (
                          <CustomForm
                            color="#222528"
                            controlText="name"
                            type="text"
                            lableText={t("signup.name")}
                            placeholderText={t("signup.enter_name")}
                            {...field}
                          />
                        )}
                      </Field>
                      {touched.name && errors.name && (
                        <div className="errorStyle">{errors.name}</div>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Field name="email">
                        {({ field }) => (
                          <CustomForm
                            color="#222528"
                            controlText="email"
                            type="email"
                            lableText={t("signup.email")}
                            placeholderText={t("signup.enter_email")}
                            {...field}
                          />
                        )}
                      </Field>
                      {touched.email && errors.email && (
                        <div className="errorStyle">{errors.email}</div>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Field name="phone_number">
                        {({ field }) => (
                          <CustomForm
                            color="#222528"
                            controlText="phone_number"
                            type="text"
                            lableText={t("signup.phone")}
                            placeholderText={t("signup.enter_phone")}
                            {...field}
                          />
                        )}
                      </Field>
                      {touched.phone_number && errors.phone_number && (
                        <div className="errorStyle">{errors.phone_number}</div>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Field name="password">
                        {({ field }) => (
                          <CustomForm
                            color="#222528"
                            controlText="password"
                            type="password"
                            lableText={t("signup.password")}
                            placeholderText={t("signup.enter_password")}
                            {...field}
                          />
                        )}
                      </Field>
                      {touched.password && errors.password && (
                        <div className="errorStyle">{errors.password}</div>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Check
                        name="is_infulencer"
                        type="checkbox"
                        label={t("signup.influencer")}
                        className={currentLanguage === "he" ? "rtl-checkbox" : "ltr-checkbox"}
                        onChange={(e) => {
                          setFieldValue("is_infulencer", e.target.checked);
                        }}
                      />

                    </Form.Group>

                    <Button type="submit" className="btn btn-primary w-100" disabled={Loading}>
                      {Loading ? <span className="spinner"></span> : t("signup.sign_up")}
                    </Button>

                    <p className="text-center">
                      {t("signup.already_have_account")}{" "}
                      <Link to="/login" className="forgotPassword forgotPassword1">
                        {t("signup.login")}
                      </Link>
                    </p>

                    <div className="orBox">
                      <span>{t("signup.or")}</span>
                    </div>

                    <div className="loginSocial">
                      <Link>
                        <Icon icon="logos:facebook" fontSize={24} />
                      </Link>
                      <GoogleLoginButton
                        data={{
                          is_influencer: false,
                          account_type: "user",
                        }}
                      />
                      <Link>
                        <Icon icon="ic:baseline-apple" color="#000000" fontSize={30} />
                      </Link>
                    </div>
                  </FormikForm>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserSignUp;
